<div class="mock-data-switcher" [class.expanded]="isExpanded">
  <div class="switcher-toggle"
       (click)="toggleExpanded()"
       (keydown.enter)="toggleExpanded()"
       (keydown.space)="toggleExpanded()"
       role="button"
       tabindex="0"
       aria-label="Developer menu toggle">
    <img src="assets/images/htx-logo.png" alt="HT-X" class="toggle-logo">
    <span class="toggle-label">Entwicklermenü</span>
    <span class="toggle-icon">{{ isExpanded ? '▼' : '▲' }}</span>
  </div>

  @if (isExpanded) {
    <div class="switcher-menu">
      <div class="menu-header">Entwicklerkonfiguration</div>

      @for (category of categories; track category.id) {
        <div class="category-section">
          <button
            class="category-header"
            (click)="toggleCategory(category.id)"
            [class.expanded]="isCategoryExpanded(category.id)"
          >
            <div class="category-info">
              <span class="category-label">{{ getCategoryLabel(category) }}</span>
              <span class="category-current">{{ getCurrentModeLabel(category) | async }}</span>
            </div>
            <span class="category-arrow">{{ isCategoryExpanded(category.id) ? '▼' : '▶' }}</span>
          </button>

          @if (isCategoryExpanded(category.id)) {
            <div class="category-modes">
              @for (mode of category.modes; track mode.value) {
                <button
                  class="mode-button"
                  [class.active]="(getCurrentMode(category.id) | async) === mode.value"
                  (click)="switchMode(category, mode)"
                >
                  <span class="mode-icon">{{ mode.icon }}</span>
                  <span class="mode-label">{{ mode.label }}</span>
                  @if ((getCurrentMode(category.id) | async) === mode.value) {
                    <span class="checkmark">✓</span>
                  }
                </button>
              }

              @if (category.id === 'comments') {
                @if (hasCustomComments() && !clearConfirmationActive) {
                  <button
                    class="mode-button clear-button"
                    (click)="initiateClearComments($event)"
                  >
                    <span class="mode-icon">🗑️</span>
                    <span class="mode-label">Clear Custom Comments</span>
                  </button>
                }

                @if (clearConfirmationActive) {
                  <div class="clear-confirmation">
                    <div class="confirmation-text">Delete all custom comments?</div>
                    <div class="confirmation-buttons">
                      <button class="confirm-btn yes" (click)="confirmClearComments($event)">
                        Yes, Delete
                      </button>
                      <button class="confirm-btn no" (click)="cancelClearComments($event)">
                        Cancel
                      </button>
                    </div>
                  </div>
                }
              }

              @if (category.id === 'organizations' && hasCustomOrganizations() && !clearOrganizationConfirmationActive) {
                <button
                  class="mode-button clear-button"
                  (click)="initiateClearOrganizations($event)"
                >
                  <span class="mode-icon">🗑️</span>
                  <span class="mode-label">Clear Custom Organizations</span>
                </button>
              }

              @if (category.id === 'organizations' && clearOrganizationConfirmationActive) {
                <div class="clear-confirmation">
                  <div class="confirmation-text">Delete all custom organizations?</div>
                  <div class="confirmation-buttons">
                    <button class="confirm-btn yes" (click)="confirmClearOrganizations($event)">
                      Yes, Delete
                    </button>
                    <button class="confirm-btn no" (click)="cancelClearOrganizations($event)">
                      Cancel
                    </button>
                  </div>
                </div>
              }

              @if (hasCustomMembers() && !clearMembersConfirmationActive) {
                <button
                  class="mode-button clear-button"
                  (click)="initiateClearMembers($event)"
                >
                  <span class="mode-icon">🗑️</span>
                  <span class="mode-label">Clear Custom Members</span>
                </button>
              }

              @if (clearMembersConfirmationActive) {
                <div class="clear-confirmation">
                  <div class="confirmation-text">Delete all custom members?</div>
                  <div class="confirmation-buttons">
                    <button class="confirm-btn yes" (click)="confirmClearMembers($event)">
                      Yes, Delete
                    </button>
                    <button class="confirm-btn no" (click)="cancelClearMembers($event)">
                      Cancel
                    </button>
                  </div>
                </div>
              }

              @if (hasCustomStateChanges() && !clearStateChangesConfirmationActive) {
                <button
                  class="mode-button clear-button"
                  (click)="initiateClearStateChanges($event)"
                >
                  <span class="mode-icon">🗑️</span>
                  <span class="mode-label">Clear Updated Data</span>
                </button>
              }

              @if (clearStateChangesConfirmationActive) {
                <div class="clear-confirmation">
                  <div class="confirmation-text">Delete all updated data (approvals, rejections, edits)?</div>
                  <div class="confirmation-buttons">
                    <button class="confirm-btn yes" (click)="confirmClearStateChanges($event)">
                      Yes, Delete
                    </button>
                    <button class="confirm-btn no" (click)="cancelClearStateChanges($event)">
                      Cancel
                    </button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
